export default __webpack_public_path__ + "static/krankentransporte-67426f6621a658c8e975611b6e614ecb.png";